import React from "react";
import { Link } from "react-router-dom";
import Framework from "@beardeddevops/react.framework";
import {Objects, Types} from "components";
import LocationCard from '../Parts/LocationCard';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Button, Progress, Modal, ModalHeader, ModalBody, Table} from "reactstrap";
import { Tooltip } from '@material-ui/core';
import {LineChart, PieChart} from 'react-chartkick';
import 'chart.js';
import ObjectOverride from "components/ObjectOverride";
import API from "@beardeddevops/react.api";
import UniversalModalOverride from "../UniversalModalOverride";
import WarningAlert from "../Elements/DispositionPendingWarningAlert";

const {getFullID} = Framework.Utilities;

/**
 *  @property {Dashboard_Object} state
 *  @property {object} model
 *  @property {Dashboard_Properties} model.properties
 *  @property {Dashboard_Is} model.is
 *  @property {Dashboard_Has} model.has
 */
class Dashboard extends ObjectOverride {

	static defaultProps = {
		locations: []
	}

	constructor(props) {
		super(props, Types.Dashboard._name);
		this.state.transactions = [];
		this.state.totals = [];
		this.state.colors = ["#67809f", "#1bbc9b", "#95a5a6", "#c8d046", "#d64635", "#6a0dad"];
		this.state.modalDataUsageOpen = false;
		this.state.dataUsageBreakdown = null;
		this.account_level = true;
	}

	handleDefaultBoundBookRoute = (e) => {
		const pkey = e.currentTarget.name;
		this.props.history.push(`/locations/${pkey}`);
	}

	handleBoundBookRoute = (e) => {
		const [locationPKey, boundBookPKey] = e.currentTarget.name.split('|');
		this.props.history.push(`/locations/${locationPKey}/${boundBookPKey}`);
	}

	handleDefaultBoundBookDownloadRoute = (e) => {
		const pkey = e.currentTarget.name;
		this.props.history.push(`/locations/${pkey}#downloads`);
	}

	handleBoundBookDownloadRoute = (e) => {
		const [locationPKey, boundBookPKey] = e.currentTarget.name.split('|');
		this.props.history.push(`/locations/${locationPKey}/${boundBookPKey}#downloads`);
	}

	handleDavidsons = () => {
		let dModel = new API.BuildClass(Types.Davidsons._name, API.RequestType.CREATE);
		dModel.submit(null, API.RequestType.CREATE);
	}

	//Progress Bars Styles
	getProgressColor = (count, limit) => {
		if (count / limit < .5) {
			return 'success';
		} else if (count / limit < .8) {
			return 'warning';
		} else {
			return 'danger';
		}
	}

	progressLabelStyle = {
		position: 'absolute',
		left: '50%',
		transform: 'translate(-50%)',
		color: 'black'
	};
	//End Progress Bars Styles

	dataUsageLabel = (count, limit) => {
		return Math.round((count / limit) * 100);
	}

	convertByteSize = (byteInKB) => Math.round(byteInKB / 1000).toLocaleString();

	getDisplayMonth = () => {
		const currentDate = new Date();
		const currentDay = currentDate.getDate();

		if (currentDay > this.props.location.subscription_start_date) {
			currentDate.setMonth(currentDate.getMonth() + 1);
		}

		return currentDate.toLocaleString('default', {month: 'long'});
	}

	getDisplayDay = () => {
		const { subscription_start_date } = this.props.location;
		const currentDate = new Date();
		const currentMonth = currentDate.getMonth() + 1;
		const currentYear = currentDate.getFullYear();

		const isLeapYear = (year) => year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
		const has30Days = [4, 6, 9, 11].includes(currentMonth);
		const isFebruary = currentMonth === 2;

		if (isFebruary) {
			const februaryDays = isLeapYear(currentYear) ? 29 : 28;
			return Math.min(subscription_start_date, februaryDays);
		} else if (subscription_start_date === 31 && has30Days) {
			return 30;
		}

		return subscription_start_date;
	}

	correctNumberSuffix = (number) => {
		let lastTwoDigits = number % 100;
		let lastDigit = number % 10;

		if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
			return "th";
		}

		switch (lastDigit) {
			case 1: return 'st';
			case 2: return 'nd';
			case 3: return 'rd';
			default: return 'th';
		}
	}

	handleClick = () => {
		this.props.history.push("/accounts/market_place#upgrades");
	}

	handleBreakdownClick = async() => {
		let locationBreakdown = new API.BuildClass(Types.Filesizes._name, 'GET_LOCATION_BREAKDOWN');
		locationBreakdown.filter = this.props.location.pkey;
		let result = await locationBreakdown.submit(null, 'GET_LOCATION_BREAKDOWN');
		this.setState({
			dataUsageBreakdown: result,
			modalDataUsageOpen: true
		});
	}

	async sendEmail() {
		/** @type {Locations_Object} */
		let location = this.props.location;
		let routeID = getFullID(location);

		this.setState({loading: true});
		let teModel = new API.BuildClass(Types.Locations._name, API.RequestType.READ);
		teModel.object.pkey = routeID;
		teModel.object.send_email_to = this.state.send_email_to;
		teModel.response_message = 'Email Sent';
		try {
			await teModel.submit(null, 'POST_SEND');
		} catch (e) {
			// console.error(e);
		}
		this.setState({loading: false});
	}

	closeModal = () => {
		this.setState({modalSendFFL: false, key: Math.random()})
	}

	//Note: Doesn't need a form() function. Only ever used in a modal
	render() {
		/** @type {Locations_Object} */
		let location = this.props.location;
		/** @type {Dashboard_Object} object */
		let object = this.state;
		let {loading} = this.state;
		let { rootState } = this.props;
		let routeID = getFullID(location);
		let locationAddressString = `${location.street_1} ${location.street_2 || ''} ${location.city}, ${location.state} ${location.zip}`;

		const categories = [
			{ key: 'forms', label: 'Forms', icon: 'fa-file-text-o' },
			{ key: 'images', label: 'Images', icon: 'fa-image' },
			{ key: 'uploaded', label: 'Uploaded', icon: 'fa-upload' },
			{ key: 'free', label: 'Free', icon: 'fa-hdd-o' }
		];

		const totalUsed = this.state.dataUsageBreakdown
			? Number(this.state.dataUsageBreakdown.forms || 0) + Number(this.state.dataUsageBreakdown.images || 0) + Number(this.state.dataUsageBreakdown.uploaded || 0)
			: 0;
		const totalLimit = this.props.location.data_usage_limit || 0;
		const free = totalLimit - totalUsed;

		const getPercentage = (value) => {
			return totalLimit ? ((value / totalLimit) * 100).toFixed(2) : 0;
		};

		return (
			<div>
				<div>
					{this.props.rootState.all_locations_expired && <WarningAlert
						warningName={'No Active Subscriptions'}
						warningMessage={'Please correct Billing Information, and then resubscribe to a location, all locations currently have inactive subscriptions'}
						url={'https://' + window.location.href.split('//')[1].split('/')[0] + '/locations' }
						urlText={' Go to locations'}
						hideButton={true}
					/>}
				</div>
				<Card>
					{!rootState.kioskMode && <CardContent>
						<div className={'row'}>
							<div className={'col-md-2'} style={{paddingTop: 10}}>
								<Link
									className="location"
									data-id={`dashboard-locations-${routeID}`}
									variant="text"
									to={`/locations/${routeID}`}
									style={{
										fontSize: '20px',
										fontWeight: '600',
										color: '#67809f'
									}}
								>
									<i className="fa fa-building-o"/>
									<span className="nav-text"><strong>  {location.name_display || location.name}</strong></span>
									<br/>
									<span className="nav-text" style={{
										fontSize: '14px',
										fontWeight: '400',
										color: '#7c7c7c',
										fontStyle: 'italic'
									}}>
										{locationAddressString}
									</span>
									<br/>
									<span className="nav-text" style={{
										fontSize: '16px',
										fontWeight: '400',
										color: '#484848',
										fontStyle: 'italic'
									}}>
										<b>{location.subscriptions && <span>{location.subscriptions.description}</span>}</b>
									</span>
								</Link>
							</div>
							<div className={'col-md'}>
								<div className={'row'} style={{marginTop: 20}}>
									<div className={'col'}>
										<Tooltip title={`Resets on ${this.getDisplayDay()}${this.correctNumberSuffix(this.getDisplayDay)} of ${this.getDisplayMonth()}`}
										         placement="top"
										         arrow>
											<div className='text-center'>Acquisitions</div>
										</Tooltip>
										<Tooltip title={'Click on bar to visit Marketplace'}
										         placement="bottom"
										         arrow>
											<div style={{cursor: 'pointer'}}>
												<Progress value={this.state.acq_count}
												          max={this.state.acq_limit}
												          color={this.getProgressColor(this.state.acq_count, this.state.acq_limit)}
												          onClick={this.handleClick}>
													<div style={this.progressLabelStyle}>
														{this.state.acq_count} of {this.state.acq_limit}
													</div>
												</Progress>
											</div>
										</Tooltip>
									</div>
									<div className={'col'}>
										<Tooltip title={`Resets on ${this.getDisplayDay()}${this.correctNumberSuffix(this.getDisplayDay)} of ${this.getDisplayMonth()}`}
										         placement="top"
										         arrow>
											<div className='text-center'>Dispositions</div>
										</Tooltip>
										<Tooltip title={'Click on bar to visit Marketplace'}
										         placement="bottom"
										         arrow>
											<div style={{cursor: 'pointer'}}>
												<Progress value={this.state.dispo_count}
												          max={this.state.dispo_limit}
												          color={this.getProgressColor(this.state.dispo_count, this.state.dispo_limit)}
												          onClick={this.handleClick}>
													<div style={this.progressLabelStyle}>
														{this.state.dispo_count} of {this.state.dispo_limit}
													</div>
												</Progress>
											</div>
										</Tooltip>
									</div>
									<div className={'col'}>
										<div className='text-center'>Storage</div>
										<Tooltip title={'Click on bar to view data usage breakdown'}
										         placement="bottom"
										         arrow>
											<div style={{cursor: 'pointer'}}>
												<Progress value={this.props.location.data_usage}
												          max={this.props.location.data_usage_limit}
												          color={this.getProgressColor(this.props.location.data_usage, this.props.location.data_usage_limit)}
												          onClick={this.handleBreakdownClick}>
													<div style={this.progressLabelStyle}>
														{`${this.dataUsageLabel(this.props.location.data_usage, this.props.location.data_usage_limit)}% of ${this.convertByteSize(this.props.location.data_usage_limit)}MB`}
													</div>
												</Progress>
											</div>
										</Tooltip>
									</div>
								</div>
							</div>
							<div className={'col-md-2'} style={{paddingTop: 22}}>
								<div style={{marginBottom: '10px'}}>
									<div style={{marginTop: '-1px', marginLeft: '6px', float: 'right', paddingBottom: 10}} className={'mr-auto'}>
										<Button style={{height: '34px', paddingTop: 4}} className={'btn-block green-meadow'} onClick={this.toggle('modalSendFFL')}>Send a copy of my FFL</Button>
									</div>
									<UniversalModalOverride
										title={"Send My FFL"}
										name={"Send My FFL"}
										submitLabel={"Send"}
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
										id={routeID}
										object={Objects.SendMyFFL}
										toggle={this.state['modalSendFFL']}
										reportClose={this.closeModal}
										hideGoTo={true}
									/>
								</div>
							</div>
						</div>
						<hr/>
						<div>
							<LocationCard
								name={location.bound_book || 'Primary'}
								description="Default bound book for this location."
								inStockQuantity={object.in_stock[0]}
								boundBookRouteID={routeID}
								boundBookDownloadRouteID={routeID}
								onBoundBookClick={this.handleDefaultBoundBookRoute}
								onBoundBookDownloadClick={this.handleDefaultBoundBookDownloadRoute}
							/>
							{location.location_bound_bookss.map((bound_book, key) => {
								/** @type {Locations_Bound_Books_Object} bound_book */
								let routeID = `${getFullID(location)}|${getFullID(bound_book)}`;
								return (
									<LocationCard
										key={key}
										name={bound_book.name}
										inStockQuantity={object.in_stock[bound_book.binary_id + '-' + bound_book.pkey]}
										boundBookRouteID={routeID}
										boundBookDownloadRouteID={routeID}
										onBoundBookClick={this.handleBoundBookRoute}
										onBoundBookDownloadClick={this.handleBoundBookDownloadRoute}
									/>
								);
							})}
						</div>
						<hr/>
						<div>
							<div className={'row'}>
								<div className={'col-md-9'}>
									<h5>Transactions Over 30 Days</h5>
									<LineChart colors={this.state.colors} data={this.state.transactions}/>
								</div>
								<div className={'col-md-3'}>
									<h5>30 Day Total By Transaction Type</h5>
									<PieChart colors={this.state.colors} data={this.state.totals}/>
								</div>
							</div>
						</div>
						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>}
				</Card>
				<Modal
					isOpen={this.state.modalDataUsageOpen}
					toggle={() => this.setState({modalDataUsageOpen: !this.state.modalDataUsageOpen})}
					size="lg"
				>
					<ModalHeader toggle={() => this.setState({modalDataUsageOpen: !this.state.modalDataUsageOpen})}>
						Storage Usage Breakdown
					</ModalHeader>
					<ModalBody>
						<Card>
							<CardContent>
								<div className="mb-4">
									<h5>Total Storage Usage</h5>
									<Progress
										value={totalUsed}
										max={totalLimit}
										color={this.getProgressColor(totalUsed, totalLimit)}
									>
										<div style={{
											position: 'absolute',
											left: '50%',
											transform: 'translate(-50%)',
											color: 'black'
										}}>
											{this.convertByteSize(totalUsed)}MB of {this.convertByteSize(totalLimit)}MB ({((totalUsed / totalLimit) * 100).toFixed(2)}%)
										</div>
									</Progress>
								</div>
								<h5>Detailed Breakdown</h5>
								<Table hover responsive className="mt-3">
									<thead>
										<tr>
											<th style={{ width: '5%' }}></th>
											<th style={{ width: '25%' }}>Category</th>
											<th style={{ width: '15%' }}>Size</th>
											<th style={{ width: '15%' }}>% of Total</th>
											<th style={{ width: '40%' }}>Usage</th>
										</tr>
									</thead>
									<tbody>
										{categories.map((category) => {
											const value = category.key === 'free' ? free : this.state.dataUsageBreakdown?.[category.key] || 0;
											const percentage = getPercentage(value);

											return (
												<tr key={category.key}>
													<td className="text-center">
														<i className={`fa ${category.icon}`} style={{ fontSize: '1.25rem' }}></i>
													</td>
													<td>{category.label}</td>
													<td>{this.convertByteSize(value)}MB</td>
													<td>{percentage}%</td>
													<td>
														<Progress
															value={value}
															max={totalLimit}
															color={category.key === 'free' ? 'info' : this.getProgressColor(value, totalLimit)}
															style={{ height: '20px' }}
														/>
													</td>
												</tr>
											);
										})}
									</tbody>
								</Table>
							</CardContent>
						</Card>
					</ModalBody>
				</Modal>
			</div>
		)
	}
}

export default Framework.Components.withRootState(Dashboard);